// extracted by mini-css-extract-plugin
module.exports = {"button":"supplier-edit-modal_button_1d-wC","status":"supplier-edit-modal_status_1JHz8","taxRate":"supplier-edit-modal_taxRate_x2e3q"};